import { makeAutoObservable } from 'mobx';
import { validateCandleMagnitude } from './validateCandleMagnitude';

export class CandleMagnitudeData {
  candleDuration = 1;
  numberOfPivots = 0;
  qtyPctPerPivot = [];
  exitInPivotCandle = 'high_low'; // high_low or mid
  usePivotsAsTrails = false;
  filterInsideCandleMagnitudes = false;
  timeUnit = 'MINUTES'; // MINUTES, HOURS, DAYS, WEEKS, MONTHS, QUARTERS, YEARS
  useAtr = false;
  ATR = {
    candlesBack: 14, //field # of candles
    atrType: 'WILDER', //options: SMA, WILDER, SMA_NO_GAP. drop down. wilder used 90% of time
    candleDuration: 1, //do candle duration + time unit combo
    timeUnit: 'MINUTES',
  };
  filterFirstMagnitudeBasedOnAtr = false; //think of this section like the repeating design. checkbox "a"
  pctOfAtrForFilter = 0.0; //field "a" as % of atr
  filterAllMagnitudeBasedOnAtr = false;
  pctOfAtrForFilterAllMag = 0;
  useAtrInsteadOfMag = false;
  pctAtrInsteadOfMag = 0;
  generateFromAtrWhenNoPivots = false;
  pctAtrGenerateAtrWhenNoPivots = 100;

  initialStop = 'NONE'; //NONE, ATR,CANDLE_RETRACE,CANDLE_HIGH_LOW
  pctAtrInitialStop = 0;
  pctRetraceInitialStop = 0;

  firstTargetStop = 'NONE'; //NONE,ATR,CANDLE_RETRACE,CANDLE_HIGH_LOW,BREAK_EVEN
  pctAtrFirstTargetStop = 0;
  pctRetraceFirstTargetStop = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach((field) => {
        if (
          field === 'pctOfAtrForFilter' ||
          field === 'pctOfAtrForFilterAllMag' ||
          field === 'pctAtrInsteadOfMag' ||
          field === 'pctAtrGenerateAtrWhenNoPivots' ||
          field === 'pctAtrInitialStop' ||
          field === 'pctRetraceInitialStop' ||
          field === 'pctAtrFirstTargetStop' ||
          field === 'pctRetraceFirstTargetStop'
        ) {
          this[field] = Number(initialData[field]) * 100;
        } else if (field === 'qtyPctPerPivot') {
          this.qtyPctPerPivot = initialData.qtyPctPerPivot.map(
            (item) => Number(item) * 100
          );
        } else {
          this[field] = initialData[field];
        }
      });
    }
  }
  resetToDefaults = () => {
    this.candleDuration = 1;
    this.numberOfPivots = 0;
    this.qtyPctPerPivot = [];
    this.exitInPivotCandle = 'high_low'; // high_low or mid
    this.usePivotsAsTrails = false;
    this.filterInsideCandleMagnitudes = false;
    this.timeUnit = 'MINUTES'; // MINUTES, HOURS, DAYS, WEEKS, MONTHS, QUARTERS, YEARS
    this.useAtr = false;
    this.ATR = {
      candlesBack: 14, //field # of candles
      atrType: 'WILDER', //options: SMA, WILDER, SMA_NO_GAP. drop down. wilder used 90% of time
      candleDuration: 1, //do candle duration + time unit combo
      timeUnit: 'MINUTES',
    };
    this.filterFirstMagnitudeBasedOnAtr = false; //think of this section like the repeating design. checkbox "a"
    this.pctOfAtrForFilter = 0.0; //field "a" as % of atr
    this.filterAllMagnitudeBasedOnAtr = false;
    this.pctOfAtrForFilterAllMag = 0;
    this.useAtrInsteadOfMag = false;
    this.pctAtrInsteadOfMag = 0;
    this.generateFromAtrWhenNoPivots = false;
    this.pctAtrGenerateAtrWhenNoPivots = 100;
    this.initialStop = 'NONE'; //NONE, ATR,CANDLE_RETRACE,CANDLE_HIGH_LOW
    this.pctAtrInitialStop = 0;
    this.pctRetraceInitialStop = 0;
    this.firstTargetStop = 'NONE'; //NONE,ATR,CANDLE_RETRACE,CANDLE_HIGH_LOW,BREAK_EVEN
    this.pctAtrFirstTargetStop = 0;
    this.pctRetraceFirstTargetStop = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateCandleMagnitude(this);
    return result;
  };
  returnJson = () => {
    return {
      candleDuration: this.candleDuration,
      numberOfPivots: this.numberOfPivots,
      qtyPctPerPivot: this.qtyPctPerPivot.map((item) => Number(item) / 100),
      exitInPivotCandle: this.exitInPivotCandle, // high_low or mid
      usePivotsAsTrails: this.usePivotsAsTrails,
      filterInsideCandleMagnitudes: this.filterInsideCandleMagnitudes,
      timeUnit: this.timeUnit, // MINUTES, HOURS, DAYS, WEEKS, MONTHS, QUARTERS, YEARS
      useAtr: this.useAtr,
      ATR: this.ATR,
      filterFirstMagnitudeBasedOnAtr: this.filterFirstMagnitudeBasedOnAtr, //think of this section like the repeating design. checkbox "a"
      pctOfAtrForFilter: Number(this.pctOfAtrForFilter) / 100, //field "a" as % of atr
      filterAllMagnitudeBasedOnAtr: this.filterAllMagnitudeBasedOnAtr,
      pctOfAtrForFilterAllMag: Number(this.pctOfAtrForFilterAllMag) / 100,
      useAtrInsteadOfMag: this.useAtrInsteadOfMag,
      pctAtrInsteadOfMag: Number(this.pctAtrInsteadOfMag) / 100,
      generateFromAtrWhenNoPivots: this.generateFromAtrWhenNoPivots,
      pctAtrGenerateAtrWhenNoPivots:
        Number(this.pctAtrGenerateAtrWhenNoPivots) / 100,
      initialStop: this.initialStop, //NONE, ATR,CANDLE_RETRACE,CANDLE_HIGH_LOW
      pctAtrInitialStop: Number(this.pctAtrInitialStop) / 100,
      pctRetraceInitialStop: Number(this.pctRetraceInitialStop) / 100,
      firstTargetStop: this.firstTargetStop, //NONE,ATR,CANDLE_RETRACE,CANDLE_HIGH_LOW,BREAK_EVEN
      pctAtrFirstTargetStop: Number(this.pctAtrFirstTargetStop) / 100,
      pctRetraceFirstTargetStop: Number(this.pctRetraceFirstTargetStop) / 100,
    };
  };
  setCandleDuration = (number) => {
    this.candleDuration = number;
  };
  setNumberOfPivots = (number) => {
    this.numberOfPivots = number;
  };
  setQtyPctPerPivot = (array) => {
    this.qtyPctPerPivot = array;
  };
  setExitInPivotCandle = (string) => {
    this.exitInPivotCandle = string;
  };
  setUsePivotsAsTrails = (bool) => {
    this.usePivotsAsTrails = bool;
  };
  setFilterInsideCandleMagnitudes = (bool) => {
    this.filterInsideCandleMagnitudes = bool;
  };
  setTimeUnit = (string) => {
    this.timeUnit = string;
  };
  setUseAtr = (bool) => {
    this.useAtr = bool;
  };
  setCandlesBack = (number) => {
    this.ATR.candlesBack = number;
  };
  setAtrType = (string) => {
    this.ATR.atrType = string;
  };
  setAtrCandleDuration = (number) => {
    this.ATR.candleDuration = number;
  };
  setAtrTimeUnit = (string) => {
    this.ATR.timeUnit = string;
  };
  setFilterFirstMagnitudeBasedOnAtr = (bool) => {
    this.filterFirstMagnitudeBasedOnAtr = bool;
  };
  setPctOfAtrForFilter = (number) => {
    this.pctOfAtrForFilter = number;
  };
  setFilterAllMagnitudeBasedOnAtr = (bool) => {
    this.filterAllMagnitudeBasedOnAtr = bool;
  };
  setPctOfAtrForFilterAllMag = (number) => {
    this.pctOfAtrForFilterAllMag = number;
  };
  setUseAtrInsteadOfMag = (bool) => {
    this.useAtrInsteadOfMag = bool;
  };
  setPctAtrInsteadOfMag = (number) => {
    this.pctAtrInsteadOfMag = number;
  };
  setGenerateFromAtrWhenNoPivots = (bool) => {
    this.generateFromAtrWhenNoPivots = bool;
  };
  setPctAtrGenerateAtrWhenNoPivots = (number) => {
    this.pctAtrGenerateAtrWhenNoPivots = number;
  };
  setInitialStop = (string) => {
    this.initialStop = string;
  };
  setPctAtrInitialStop = (number) => {
    this.pctAtrInitialStop = number;
  };
  setPctRetraceInitialStop = (number) => {
    this.pctRetraceInitialStop = number;
  };
  setFirstTargetStop = (string) => {
    this.firstTargetStop = string;
  };
  setPctAtrFirstTargetStop = (number) => {
    this.pctAtrFirstTargetStop = number;
  };
  setPctRetraceFirstTargetStop = (number) => {
    this.pctRetraceFirstTargetStop = number;
  };
}
